import {Component, OnDestroy, OnInit} from '@angular/core';
import {BaseGeneralComponent} from '../../../BaseGeneralComponent';
import {RegionModel} from '../../../../models/RegionModel';
import {Subscription} from 'rxjs';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {RateCardModel} from '../../../../models/RateCardModel';
import {CurrencyModel} from '../../../../models/CurrencyModel';
import {RoleAnagrafModel} from '../../../../models/RoleAnagrafModel';
import {RateTypeModel} from '../../../../models/RateTypeModel';
import {RateCardService} from '../service-rate-card/rate-card.service';
import * as toastr from 'toastr';
import {NumAnnoMeseService} from '../../../general-services/service-num-anno-mese/num-anno-mese.service';

@Component({
  selector: 'app-new-rate-card',
  templateUrl: './new-rate-card.component.html',
  styleUrls: ['./new-rate-card.component.scss']
})
export class NewRateCardComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  showActions: boolean;
  anagrafInSettings: boolean;

  rateCard: RateCardModel;
  regionSelect: RegionModel;
  currencySelect: CurrencyModel;
  roleSelect: RoleAnagrafModel;
  rateTypeSelect: RateTypeModel;
  saveRateCard: Subscription;

  showRegion: boolean;
  showCurrency: boolean;
  showRole: boolean;
  showRateType: boolean;

  registerForm: FormGroup;
  submitted = false;

  allYear: any;
  getPageSubscribe: Subscription;

  constructor(private route: ActivatedRoute, private router: Router,
              private rateCardService: RateCardService,
              private formBuilder: FormBuilder,
              private loaderService: LoaderService,
              private annoMeseService: NumAnnoMeseService) {
    super();

    this.showActions = false;
    this.anagrafInSettings = true;
    this.showRegion  = false;
    this.showRateType = false;
    this.showCurrency = false;
    this.showRole = false;
    this.rateCard = new RateCardModel();
    this.regionSelect = new RegionModel();
    this.currencySelect = new CurrencyModel();
    this.roleSelect = new RoleAnagrafModel();
    this.rateTypeSelect = new RateTypeModel();

  }

  ngOnInit() {
    this.registerForm = this.formBuilder.group({
      region: [{value: '', disabled: false}, Validators.required],
      currency: [{value: '', disabled: false}, Validators.required],
      role: [{value: '', disabled: false}, Validators.required],
      rateType: [{value: '', disabled: false}, Validators.required],
      transitionOs: [{value: '', disabled: false}, Validators.required],
      onsiteFts: [{value: '', disabled: false}, Validators.required],
      hours: [{value: '', disabled: false}, Validators.required],
      year1: [{value: '', disabled: false}, Validators.required],
      year1Ammount: [{value: '', disabled: false}, Validators.required],
      year2: [{value: '', disabled: false}, Validators.required],
      year2Ammount: [{value: '', disabled: false}, Validators.required],
      year3: [{value: '', disabled: false}, Validators.required],
      year3Ammount: [{value: '', disabled: false}, Validators.required]
    });

    this.getAllYear();
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 5}});
  }


  save() {
    this.submitted = true;
    if (this.registerForm.valid) {
      this.rateCard.transitionOs = this.registerForm.value.transitionOs;
      this.rateCard.onsiteFts = this.registerForm.value.onsiteFts;
      this.rateCard.hours = this.registerForm.value.hours;
      this.rateCard.year1 = this.registerForm.value.year1;
      this.rateCard.year1Ammount = this.registerForm.value.year1Ammount;
      this.rateCard.year2 = this.registerForm.value.year2;
      this.rateCard.year2Ammount = this.registerForm.value.year2Ammount;
      this.rateCard.year3 = this.registerForm.value.year3;
      this.rateCard.year3Ammount = this.registerForm.value.year3Ammount;
      event.preventDefault();
      this.loaderService.display(true);
      this.saveRateCard = this.rateCardService.save(this.rateCardService.baseUrl + '/save', this.rateCard)
        .subscribe(
          (result: any) => {
            if (result === -1) {
              toastr.options.timeout = 5000;
              toastr.warning('Duplicate item, cannot be created', 'Warning');
              this.loaderService.display(false);
            } else {
              toastr.success('Minimum Commitment was created with success', 'Success');
              this.loaderService.display(false);
              this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 5}});
            }
          },
          error => {
            toastr.error('Minimum Commitment was not created', 'Error');
            this.loaderService.display(false);
          });
    }
  }


  ngOnDestroy(): void {
    if (this.saveRateCard) {
      this.saveRateCard.unsubscribe();
    }
  }

  getElementSelectedRegion($event) {
    this.rateCard.region = $event.row;
    this.regionSelect = $event.row;
    this.registerForm.patchValue({
      region: this.regionSelect.cod
    });
  }

  getElementSelectedCurrency($event) {
    this.rateCard.currency = $event.row;
    this.currencySelect = $event.row;
    this.registerForm.patchValue({
      currency: this.currencySelect.cod
    });
  }

  getElementSelectedRoles($event) {
    this.rateCard.roles = $event.row;
    this.roleSelect = $event.row;
    this.registerForm.patchValue({
      role: this.roleSelect.code
    });
  }

  getElementSelectedRateType($event) {
    this.rateCard.rateType = $event.row;
    this.rateTypeSelect = $event.row;
    this.registerForm.patchValue({
      rateType: this.rateTypeSelect.code
    });
  }


  toggleRegion() {
    this.showRegion = !this.showRegion;
  }

  toggleCurrency() {
    this.showCurrency = !this.showCurrency;
  }

  toggleRole() {
    this.showRole = !this.showRole;
  }

  toggleRateType() {
    this.showRateType = !this.showRateType;
  }


  // convenience getter for easy access to form fields
  get f() { return this.registerForm.controls; }


  resetAll() {
    this.resetRegion();
    this.resetCurrency();
    this.resetRateType();
    this.resetRole();
    this.showRole = false;
    this.showRateType = false;
    this.showCurrency = false;
    this.showRegion = false;
  }

  resetRegion() {
    this.registerForm.patchValue({
      region: ''
    });
    this.regionSelect = new RegionModel();
  }

  resetCurrency() {
    this.registerForm.patchValue({
      currency: ''
    });
    this.currencySelect = new CurrencyModel();
  }

  resetRateType() {
    this.registerForm.patchValue({
      rateType: ''
    });
    this.rateTypeSelect = new RateTypeModel();
  }

  resetRole() {
    this.registerForm.patchValue({
      roleAnagraf: ''
    });
    this.roleSelect = new RoleAnagrafModel();
  }

  handleTransitionOS(value) {
    this.rateCard.transitionOs = value;
    this.registerForm.patchValue({
      transitionOs: value
    });
  }

  handleOnsiteFTS(value) {
    this.rateCard.onsiteFts = value;
    this.registerForm.patchValue({
      onsiteFts : value
    });
  }

  handleYear1(value) {
    this.rateCard.year1 = value;
    this.registerForm.patchValue({
      year1: value
    });
  }
  handleYear2(value) {
    this.rateCard.year2 = value;
    this.registerForm.patchValue({
      year2: value
    });
  }
  handleYear3(value) {
    this.rateCard.year3 = value;
    this.registerForm.patchValue({
      year3: value
    });
  }

  getAllYear() {
    this.getPageSubscribe = this.annoMeseService.getAllYear()
      .subscribe(
        (result: any) => {
          this.allYear = result;
        });
  }
}
